// extracted by mini-css-extract-plugin
module.exports = {"root":"Background_root__jHfMI","image":"Background_image__jDwHm"};